export class LeadsService {
  constructor(axios, apiUrl) {
    this.$axios = axios;
    this.apiUrl = apiUrl;
  }

  /**
   * Submit an SG contact Form
   * @param {} data
   * @returns int
   */
  async submitContactForm(data) {
    return await this.$axios.post(this.apiUrl + "LeadForms/SG/Contact", data, {
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    }).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }

  /**
   * Submit an SG Franchise Kit Form
   * @param {} data
   * @returns int
   */
  async submitFranchiseKitForm(data) {
    return await this.$axios.post(
      this.apiUrl + "LeadForms/SG/FranchiseKit",
      data
    ).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }

  /**
   * Submit an SG RequestInfo Form
   * @param {} data
   * @returns int
   */
  async submitRequestInfoForm(data) {
    return await this.$axios.post(
      this.apiUrl + "LeadForms/SG/RequestInfo",
      data
    ).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }

  /**
   * Submit an SG FranchiseLeadTrack Form
   * @param {} data
   * @returns int
   */
  async submitFranchiseLeadTrackForm(data) {
    return await this.$axios.post(
      this.apiUrl + "LeadForms/SG/FranchiseLeadTrack",
      data
    ).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }

  /**
   * Submit an SG GreenIndustryContact Form
   * @param {} data
   * @returns int
   */
  async submitGreenIndustryContactForm(data) {
    return await this.$axios.post(
      this.apiUrl + "LeadForms/SG/GreenIndustryContact",
      data
    ).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }

  /**
   * Submit an SG PpcContact Form
   * @param {} data
   * @returns object
   */
  async submitPpcContactForm(data) {
    try {
      const response =  await this.$axios.post(
        this.apiUrl + "LeadForms/SG/PpcContact",
        data,
        { params: {
          defaultExactTargetId: "OmniContactUsFormUnMatchedCust",
          matchedExactTargetId: "OmniContactUsFormMatchedCustomer"
        }}
      );

      return Promise.resolve(response.data);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  /**
   * Submit an SG contact Form
   * @param {} data
   * @returns int
   */
   async submitCareersForm(data) {
    return await this.$axios.post(this.apiUrl + "LeadForms/SG/CareerApplication", 
      data
    ).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }

  /**
   * Submit an SG Commercial Services Form
   * @param {} data
   * @returns int
   */
   async submitCommercialServicesForm(data) {
    return await this.$axios.post(this.apiUrl + "LeadForms/SG/ComercialServices", 
      data
    ).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }

}
